'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var index$1 = require('./components/index.js');
var index = require('./foundations/index.js');
var index$2 = require('./layerStyles/index.js');
var index$3 = require('./textStyles/index.js');
var styles = require('./styles.js');
var semanticTokens = require('./semanticTokens.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var direction = 'ltr';
var config = {
  useSystemColorMode: false,
  initialColorMode: 'light',
  cssVarPrefix: 'hg'
};
var theme = _objectSpread(_objectSpread({
  semanticTokens: semanticTokens.semanticTokens,
  direction: direction
}, index["default"]), {}, {
  components: index$1["default"],
  layerStyles: index$2["default"],
  textStyles: index$3["default"],
  styles: styles.styles,
  config: config
});
exports["default"] = theme;